import type { ProjectContextItem, ProjectContextSelection } from '@/features/chats/stores';

/**
 * Rebuilds a composer project-context selection from a fresh `items` list,
 * recomputing the derived `briefs` (kept inline) and `artifactIds` (id-only) so
 * they always agree with `items`. Returns undefined when nothing is left, since
 * an empty selection should clear the attachment rather than persist a husk.
 *
 * Shared by the picker (drop a chip) and the message chips (re-attach or drop a
 * past attachment) so the briefs/artifactIds bookkeeping lives in one place.
 */
export function rebuildProjectContextSelection(
  base: ProjectContextSelection,
  items: ProjectContextItem[],
): ProjectContextSelection | undefined {
  if (items.length === 0) return undefined;

  const itemIds = new Set(items.map((item) => item.id));
  return {
    ...base,
    items,
    briefs: base.briefs.filter((brief) => itemIds.has(brief.id)),
    artifactIds: items.filter((item) => item.kind !== 'brief').map((item) => item.id),
  };
}
